<section class="row">
  <section class="col-12 col-sm-12 col-md-12 col-lg-12 alignBack">
    <button class="btn-primary btn-margin-back" (click)="backToView()">
      {{'customerOverview.back'| cxTranslate}}
    </button>
  </section>
</section>

<section class="container">
  <section class="row">
    <section class="col-12 col-xs-12 col-md-12 col-lg-2 col-xl-2 white-Bg-left-panel"></section>
    <section class="col-12 col-xs-12 col-md-12 col-lg-10 col-xl-10 white-Bg">
      <section class="row sectionPadding">
        <section class="col-md-9 col-9 col-sm-9 mt-5">
          <h3>
            <span class="header-Css">
              {{'customerOverview.B2BAccountName'| cxTranslate}}
            </span>
          </h3>
        </section>
        <section class="row ml-0">
          <section class="col-lg-4 col-3 col-xs-4 col-sm-4 col-md-4 mt-10"><span class="inner-Headers">
            {{'customerOverview.id'| cxTranslate}}
          </span></section>
          <section class="col-lg-8 col-9 col-xs-8 col-sm-8 col-md-8 inner-value mt-10"><span>
          {{loginUserInfo?.unitId}}</span></section>

          <section class="col-lg-4 col-3 col-xs-4 col-sm-4 col-md-4 mt-10">
            <span class="inner-Headers">{{'profile.name'| cxTranslate}}</span>
          </section>
          <section class="col-lg-8 col-9 col-xs-8 col-sm-8 col-md-8 inner-value mt-10">
            <span>{{loginUserInfo?.unitName}}</span>
          </section>

          <section class="col-lg-4 col-3 col-xs-4 col-sm-4 col-md-4  mt-10">
            <span class="inner-Headers">{{'customerOverview.phone'| cxTranslate}}</span>
          </section>
          <section class="col-lg-8 col-9 col-xs-8 col-sm-8 col-md-8 inner-value mt-10">
            <span>{{loginUserInfo?.unitPhone}}</span>
          </section>

          <section class="col-lg-4 col-3 col-xs-4 col-sm-4 col-md-4  mt-10">
            <span class="inner-Headers">{{'customerOverview.custUserId'| cxTranslate}}</span>
          </section>
          <section class="col-lg-8 col-9 col-xs-8 col-sm-8 col-md-8 inner-value mt-10">
            <span>{{loginUserInfo?.userName}}</span>
          </section>
        </section>
      </section>
      <hr />
      <!-- =========================Name Form============================================ -->
      <section class="row sectionPadding">

        <section class="col-md-9 col-9 col-sm-9 mt-5">
          <h3>
            <span class="header-Css">
              {{'profile.name'| cxTranslate}}
            </span>
          </h3>
        </section>
        <section class="col-md-3 col-3 col-sm-3 mt-5">
          <h3 class="float-right d-flex">
            @if (nameEditIsNotClicked) {
              <img alt="" src="/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
                >
            }
            @if (nameEditIsNotClicked) {
              <span class="edit-Option" (click)="editNameField()">
                {{'profile.edit'| cxTranslate}}
              </span>
            }
          </h3>
        </section>
      </section>
            <section class="container sectionPadding" [ngClass]="{'margin-Down':nameEditIsNotClicked,
  'edited-Fields-Margin-Value':!nameEditIsNotClicked}">
        @if (nameEditIsNotClicked) {
          <section class="row">
            <section class="col-md-12">
              <label class="name-inner-Headers"> {{'profile.firstName'| cxTranslate}}</label>
            </section>
            <section class="col-md-12 inner-value">
              <span>{{
                nameForm.get("actualFirstName").value
              }}</span>
            </section>
            <section class="col-md-12">
              <label class="name-inner-Headers">{{'profile.lastName'| cxTranslate}}</label>
            </section>
            <section class="col-md-12 inner-value">
              <span>{{
                nameForm.get("actualLastName").value
              }}</span>
            </section>
          </section>
        }

        @if (!nameEditIsNotClicked) {
          <section class="row" [formGroup]="nameForm">
            <section class="col-md-12 ">
              <label class="inner-Headers">{{'profile.firstName'| cxTranslate}}</label>
            </section>
            <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value">
                        <input class="form-control  text-Field-Styling" formControlName="actualFirstName" [ngClass]="{
            required:
            nameForm.get('actualFirstName').invalid &&
              (nameForm.get('actualFirstName').touched ||nameForm.get('actualFirstName').dirty)
          }" />
              @if (
                nameForm.get('actualFirstName').value.length==0 &&
                (nameForm.get('actualFirstName').touched ||nameForm.get('actualFirstName').dirty)
                ) {
                <span class="text-danger">{{'profile.requiredError'| cxTranslate}}</span>
              }
              @if (
                nameForm.get('actualFirstName').value.length!=0 &&
                nameForm.get('actualFirstName').invalid &&
                (nameForm.get('actualFirstName').touched ||nameForm.get('actualFirstName').dirty)
                ) {
                <span class="text-danger">{{'profile.invalidName'| cxTranslate}}</span>
              }
            </section>
            <section class="col-md-12">
              <label class="inner-Headers">{{'profile.lastName'| cxTranslate}}</label>
            </section>
            <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value">
                        <input class="form-control  text-Field-Styling" formControlName="actualLastName" [ngClass]="{
            required:
              nameForm.get('actualLastName').invalid &&
              (nameForm.get('actualLastName').touched ||nameForm.get('actualLastName').dirty)
          }" />
              @if (
                (nameForm.get('actualLastName').touched ||nameForm.get('actualLastName').dirty) &&
                nameForm.get('actualLastName').value.length == 0
                ) {
                <span class="text-danger">{{'profile.requiredError'| cxTranslate}}</span>
              }
              @if (
                nameForm.get('actualLastName').value.length!=0 &&
                nameForm.get('actualLastName').invalid &&
                (nameForm.get('actualLastName').touched ||nameForm.get('actualLastName').dirty)
                ) {
                <span class="text-danger">{{'profile.invalidName'| cxTranslate}}</span>
              }
            </section>
          </section>
        }
        @if (!nameEditIsNotClicked) {
          <section class="row w-100  btn-Row">
            <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 btn-Padding">
              <button class="btn-secondary" (click)="cancelNameUpdate()">
                {{'profile.cancel'|cxTranslate}}
              </button>
            </section>
            <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 btnMargin-Top btn-Padding">
                        <button class="btn-primary" (click)="updateNameField()" [disabled]="
            nameForm.get('actualFirstName').invalid || nameForm.get('actualLastName').invalid
          ">
                {{'profile.update'|cxTranslate}}
              </button>
            </section>
          </section>
        }
      </section>
      <hr />

      <!-- =========================Role============================================ -->
      <section class="row sectionPadding">
        <section class="col-md-9 col-9 col-sm-9">
          <h3><span class="header-Css">{{'profile.role'| cxTranslate}}</span></h3>
        </section>
        <section class="col-md-3 col-3 col-sm-3">
          <h3 class="float-right">
            @if (roleEditIsNotClicked) {
              <img alt="" src="/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
                >
            }
            @if (roleEditIsNotClicked) {
              <span class="edit-Option" (click)="editRoleField()"
              >{{'profile.edit'| cxTranslate}}</span>
            }
          </h3>
        </section>
      </section>
            <section class="container sectionPadding" [ngClass]="{'margin-Down':roleEditIsNotClicked,
  'edited-Fields-Margin-Value':!roleEditIsNotClicked}">
        @if (roleEditIsNotClicked) {
          <section class="row ">
            <section class="col-md-12 inner-value">
              <span class="inner-Content inner-Content-Font-Color">{{ displayRoleofUser }}</span>
            </section>
          </section>
        }
        @if (!roleEditIsNotClicked) {
          <section class="row ">
                    <section class="col-md-12 col-12 col-sm-12 col-lg-12 col-xs-12 col-xl-5
       fields-Margin-Value role-Margin-Bottom user-Profile">
              <ng-select class="w-100" [items]="roleOfUserArray" bindLabel="name" bindValue="code"
                [multiple]="false" name="chosenRoleofUser" [clearable]="false" placeholder="Select Role"
                [(ngModel)]="chosenRoleofUser">
              </ng-select>
            </section>
          </section>
        }
        @if (!roleEditIsNotClicked) {
          <section class="row w-100  btn-Row">
            <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 btn-Padding">
              <button class="btn-secondary" (click)="cancelRoleUpdate()">
                {{'profile.cancel'|cxTranslate}}
              </button>
            </section>
            <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 btnMargin-Top btn-Padding">
              <button class="btn-primary" (click)="updateRoleField()">
                {{'profile.update'|cxTranslate}}
              </button>
            </section>
          </section>
        }
      </section>
      <hr />
      <!-- =========================reset link============================================ -->
      <section class="row sectionPadding">
        <section class="col-xl-8 col-lg-8 col-md-8 col-10 col-xs-8 col-sm-9">
          <h3><span class="header-Css">
          {{'customerOverview.PasswordReset'| cxTranslate}}</span></h3>
        </section>
        <section
          class="col-xl-4 xol-lg-4 col-md-4 col-10 col-xs-6 col-sm-6 padding-right-btn-div d-flex justify-content-end">
          <button class="btn-primary" (click)="resetPasswordLink()">
            <!-- <span class="resetLink-btn-text">  -->
            {{'customerOverview.SendResetLink'| cxTranslate}}
          <!-- </span> -->

        </button>
      </section>
      <section class="col-md-12 col-12 col-lg-12 col-xs-12">
        @if (resetPasswordBoolean===true) {
          <span>
            {{'customerOverview.successMsg'| cxTranslate}} {{loginUserInfo?.email}}
          </span>
        }
        @if (resetPasswordBoolean===false) {
          <span class="text-danger">
            {{'customerOverview.failureMsg'| cxTranslate}} {{loginUserInfo?.email}}
          </span>
        }
      </section>
    </section>

    <hr />
    <!-- ==========================================Password Recocecry============================== -->
    <section class="row sectionPadding">
      <section class="col-md-9 col-9 col-sm-9">
        <h3 class="m-0"><span class="header-Css">{{"profile.passRecQue"|cxTranslate}} </span></h3>
      </section>

    </section>
            <section class="container" [ngClass]="{'margin-Down':passRecEditIsNotClicked,
  'edited-Fields-Margin-Value':!passRecEditIsNotClicked}">
      <section class="row sectionPadding">
        <section class="col-md-12 p-0">
          <span class="inner-Content inner-Content-Font-Color">{{ displayQueForPassRecovery }}</span>
        </section>
        <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value">
          <span class="inner-Content-Font-Color">********</span>

        </section>

      </section>
      @if (!passRecEditIsNotClicked) {
        <section class="row sectionPadding">
          <section class="col-md-12">
            <label class="inner-Headers">{{"profile.passRecQue"|cxTranslate}} </label>
          </section>
                    <section class="col-md-12 col-12 col-sm-12 col-lg-12 col-xs-12 col-xl-5
      fields-Margin-Value user-Profile p-0">
            <ng-select [items]="passRecQuesArray" bindLabel="name" bindValue="code" [multiple]="false"
              name="chosenRoleofUser" [clearable]="false" placeholder="Select Question"
              [(ngModel)]="chosenQueForPassRecovery" class="w-100">
            </ng-select>
          </section>
          <section class="col-md-12 p-0">
            <label class="inner-Headers"> {{"profile.passRecAns"|cxTranslate}} </label>
          </section>
          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value">
            <input class="w-100 form-control  text-Field-Styling"
              [ngClass]="{'required':ansForQuePassRecovery=='' && ansForQuePassRecovery!=null}"
              [(ngModel)]="ansForQuePassRecovery" />
            @if (ansForQuePassRecovery=='' && ansForQuePassRecovery!=null ) {
              <span class="text-danger">
                {{'profile.requiredError'|cxTranslate}}
              </span>
            }
          </section>
        </section>
      }
      @if (!passRecEditIsNotClicked) {
        <section class="row w-100  btn-Row">
          <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 btn-Padding">
            <button class="btn-secondary" (click)="cancelPassRecUpdate()">
              {{'profile.cancel'|cxTranslate}}
            </button>
          </section>
          <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 btnMargin-Top btn-Padding">
            <button [disabled]="ansForQuePassRecovery == '' || chosenQueForPassRecovery=='' "
              class="btn-primary">
              {{'profile.update'|cxTranslate}}
            </button>
          </section>
        </section>
      }
    </section>
    <hr />
    <!-- ==========================================Email============================== -->
    <section class="row sectionPadding">
      <section class="col-md-9 col-9 col-sm-9">
        <h3 class="m-0"><span class="header-Css"> {{"profile.email"|cxTranslate}}</span></h3>
      </section>
      <section class="col-md-3 col-3 col-sm-3">
        <h3 class="float-right">
          @if (emailEditIsNotClicked) {
            <img alt="" src="/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
              />
          }
          @if (emailEditIsNotClicked) {
            <span class="edit-Option" (click)="editEmailField()"
            >{{'profile.edit'| cxTranslate}}</span>
          }
        </h3>
      </section>
    </section>
            <section class="container" [ngClass]="{'margin-Down':emailEditIsNotClicked,
  'edited-Fields-Margin-Value':!emailEditIsNotClicked}">

      @if (emailEditIsNotClicked) {
        <section class="row sectionPadding">
          <section class="col-md-12 inner-value p-0">
            <span class="inner-Content inner-Content-Font-Color">{{ emailForm.get("emailId").value }}</span>
          </section>
        </section>
      }

      @if (!emailEditIsNotClicked) {
        <section class="row sectionPadding" [formGroup]="emailForm">
          <section class="col-md-12 p-0">
            <label class="inner-Headers"> {{"profile.email"|cxTranslate}}</label>
          </section>
          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value p-0">
                        <input class="form-control  text-Field-Styling" formControlName="emailId" [ngClass]="{
            required:
              (emailForm.get('emailId').value.length == 0  || emailForm.get('emailId').invalid) &&
              (emailForm.get('emailId').touched ||  emailForm.get('emailId').dirty)
          }" />
            @if (emailForm.get('emailId').invalid &&
              (emailForm.get('emailId').dirty || emailForm.get('emailId').touched)
              && emailForm.get('emailId').value.length!=0) {
              <span class="text-danger">
                {{'profile.invalidEmail'| cxTranslate}}
              </span>
            }
            @if ((emailForm.get('emailId').dirty || emailForm.get('emailId').touched)
              && emailForm.get('emailId').value.length==0 ) {
              <span class="text-danger"> {{'profile.requiredError'| cxTranslate}}
              </span>
            }
          </section>
          <section class="col-md-12 p-0">
            <label class="inner-Headers">{{'profile.confirmEmail'| cxTranslate}}</label>
          </section>
          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value p-0">
                        <input class="form-control  text-Field-Styling" formControlName="confirmEmailId" [ngClass]="{
            required:
              (emailForm.get('confirmEmailId').value.length == 0 ||
              emailForm.get('confirmEmailId').value != emailForm.get('emailId').value) &&
              (emailForm.get('confirmEmailId').touched || emailForm.get('confirmEmailId').dirty),
            block: emailForm.get('emailId').value.length == 0
          }" />
            @if (
              emailForm.get('confirmEmailId').value !=
              emailForm.get('emailId').value &&  emailForm.get('confirmEmailId').value !=0 &&
              (emailForm.get('confirmEmailId').touched || emailForm.get('confirmEmailId').dirty)
              ) {
              <span class="text-danger">
                {{"profile.EmailIdnotMisMatch"|cxTranslate}}
              </span>
            }
            @if (
              emailForm.get('confirmEmailId').value ==0
              &&
              (emailForm.get('confirmEmailId').touched || emailForm.get('confirmEmailId').dirty)
              ) {
              <span class="text-danger">
                {{"profile.requiredError"|cxTranslate}}
              </span>
            }
          </section>
        </section>
      }
      @if (!emailEditIsNotClicked) {
        <section class="row w-100 btn-Row">
          <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 pl-12">
            <button class="btn-secondary" (click)="cancelEmailUpdate()">
              {{'profile.cancel'|cxTranslate}}
            </button>
          </section>
          <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 pl-12 btnMargin-Top ">
                        <button class="btn-primary" (click)="updateEmailField()" [disabled]="
          emailForm.invalid ||
            (emailForm.get('confirmEmailId').value !=
              emailForm.get('emailId').value)
          ">
              {{'profile.update'|cxTranslate}}
            </button>
          </section>
        </section>
      }


      @if (emailEditIsNotClicked) {
        <section class="row">
          <section class="col-md-12">
            @if (!!emailChangeRequested) {
              <p class="inner-Content mt-2 emailConstent-msg">
                {{ "profile.customerServiceEmailChange" | cxTranslate }}
                {{ "profile.confirmEmailChange" | cxTranslate }}{{"profile.clickConfirmationLink" |
                cxTranslate }}
              </p>
            }
          </section>
        </section>
      }


    </section>
    <hr />
    <!-- ==========================================Mobile Phone============================== -->
    <section class="row sectionPadding">
      <section class="col-md-9 col-9 col-sm-9">
        <h3 class="m-0"><span class="header-Css">{{'customerOverview.mobilePhoneNumber'|cxTranslate}}</span></h3>
      </section>
      <section class="col-md-3 col-3 col-sm-3">
        <h3 class="float-right">
          @if (loginUserInfo?.mobileNumber && mobileEditIsNotClicked) {
            <img alt="" src="/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"/>
          }
          @if (loginUserInfo?.mobileNumber && mobileEditIsNotClicked) {
            <span class="edit-Option" (click)="editMobileField('edit')">{{'customerOverview.edit'|cxTranslate}}</span>
          }
        </h3>
      </section>
    </section>

    <section class="container" [ngClass]="{'margin-Down': mobileEditIsNotClicked, 'edited-Fields-Margin-Value': !mobileEditIsNotClicked}">
      @if (mobileEditIsNotClicked && loginUserInfo?.mobileNumber) {
        <section class="row sectionPadding">
          <section class="col-md-12 inner-value p-0">
            <span class="inner-Content inner-Content-Font-Color">{{ mobileNumberMasked }}</span>
          </section>
        </section>
      }
      @if (!mobileEditIsNotClicked || !loginUserInfo?.mobileNumber) {
        <section class="row sectionPadding" [formGroup]="mobileForm">
          @if (!loginUserInfo?.mobileNumber) {
            <section class="col-md-12 p-0">
              <label class="phone-msg">
                <img alt="" src="/icons/{{baseSiteId}}/info.png" class="info-Icon-Image">
                {{'customerOverview.mobilePhoneNumberMsg'|cxTranslate}}
              </label>
            </section>
            <section class="col-12 col-xl-7 fields-Margin-Value p-0">
              <input class="form-control text-Field-Styling"
                placeholder="_ _ _-_ _ _-_ _ _ _"
                appPhoneMask
                (input)="validateMobileForm()"
                type="text" maxlength="12"
                formControlName="mobileNumber"/>
              @if (!!mobileErrorMsg) {
                <div class="text-danger ml-2 mb-1">{{ mobileErrorMsg }}</div>
              }
            </section>
            <section class="col-md-12 p-0 mt-2">
              <button class="btn-primary" (click)="updateMobileField()"
                [disabled]="mobileForm.get('mobileNumber').invalid || mobileAddDisable">
                {{'customerOverview.mobileAdd'|cxTranslate}}
              </button>
            </section>
          } @else {
            <section class="col-12 col-xl-7 fields-Margin-Value p-0">
              <input class="form-control text-Field-Styling"
                appPhoneMask
                (input)="validateMobileForm()"
                type="text" maxlength="12"
                formControlName="mobileNumber"/>
              @if (!!mobileErrorMsg) {
                <div class="text-danger">{{ mobileErrorMsg }}</div>
              }
            </section>
            <section class="col-md-12 p-0 mt-2">
              <button class="btn-secondary m-2" (click)="editMobileField('cancel')">
                {{'customerOverview.cancel'|cxTranslate}}
              </button>
              <button class="btn-primary m-1" (click)="updateMobileField()"
                [disabled]="mobileForm.get('mobileNumber').invalid || mobileForm.get('mobileNumber').value?.replace(/\D/g,'') == loginUserInfo.mobileNumber || mobileAddDisable">
                {{'customerOverview.update'|cxTranslate}}
              </button>
              <button class="btn-tertiary m-2" (click)="removeMobile()"
                [disabled]="mobileAddDisable">
                <img alt="" width="20" height="20" src="/icons/{{baseSiteId}}/trash.svg">
                {{'customerOverview.mobileRemove'|cxTranslate}}
              </button>
            </section>
          }
        </section>
      }
      @if (!loginUserInfo?.mobileNumber) {
        <section class="row sectionPadding pt-3 inner-Content">
          <section class="col-md-12 p-0">
            <span>{{'customerOverview.mobileDataRates'|cxTranslate}}</span><br>
            <span>{{'customerOverview.mobileAgreement'|cxTranslate}}</span><br>
            <div class="my-2">
              <a target="_blank" href="https://www.sanofi.com/en/legal-notice" rel="noopener noreferrer" class="hyperlink">
                {{'customerOverview.mobileTerms'|cxTranslate}}
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.sanofi.com/en/privacy-and-data-protection" rel="noopener noreferrer" class="hyperlink">
                {{'customerOverview.mobilePrivacy'|cxTranslate}}
              </a>
            </div>
          </section>
        </section>
      }
    </section>
    <hr />
    <!-- ==================================first radio========================================== -->
    <section class="row sectionPadding">
      <section class="col-md-9 col-9 col-sm-9">
        <h3 class="m-0"><span class="header-Css">
        {{'customerOverview.DisableUserID'| cxTranslate}}</span></h3>
      </section>
      <section class="col-md-3 col-3 col-sm-3">
        <h3 class="float-right">
          @if (userIdEditIsNotClicked) {
            <img alt="" src="/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
              />
          }
          @if (userIdEditIsNotClicked) {
            <span class="edit-Option" (click)="editUserIdRadio()"
            >{{'profile.edit'| cxTranslate}}</span>
          }
        </h3>
      </section>
    </section>
    <section class="container">
      @if (userIdEditIsNotClicked) {
        <section class="row">
          <section class="row radio-Div w-100">
            <section class="col-md-2 col-sm-3 col-lg-2">
              <div class="custom-control custom-radio radio_grp label-location">
                <input type="radio" id="emailConsentYesRadio" name="emailConsent"
                  class="custom-control-input" value='true' disabled
                  [(ngModel)]="userIdDisableReadOnly" />
                <label class="custom-control-label secloct text-capitalize" for="emailConsentYesRadio">
                  {{'customerOverview.true'| cxTranslate}}
                </label>
              </div>
            </section>
            <section class="col-md-2 col-sm-3 col-lg-2">
              <div class="custom-control custom-radio radio_grp label-location w-50">
                <input type="radio" id="emailConsentNoRadio" name="emailConsent"
                  class="custom-control-input" value='false' [(ngModel)]="userIdDisableReadOnly"
                  disabled />
                <label class="custom-control-label secloct text-capitalize" for="emailConsentNoRadio">
                  {{'customerOverview.false'| cxTranslate}}
                </label>
              </div>
            </section>
          </section>
        </section>
      }
      @if (!userIdEditIsNotClicked) {
        <section class="row">
          <section class="row radio-Div w-100">
            <section class="col-xl-12 col-lg-12 col-md-12 col-12 col-sm-12 w-100">
              <div class="custom-control custom-radio radio_grp label-location">
                <input type="radio" id="emailConsentYesRadio" name="emailConsent"
                  class="custom-control-input" value="true" [(ngModel)]="userIdDisable" />
                <label class="custom-control-label secloct text-capitalize" for="emailConsentYesRadio">
                  {{'customerOverview.true'| cxTranslate}}
                </label>
              </div>
            </section>
            <section class="col-xl-12 col-lg-12 col-md-12 col-12 col-sm-12">
              <div class="custom-control custom-radio radio_grp label-location w-50">
                <input type="radio" id="emailConsentNoRadio" name="emailConsent"
                  class="custom-control-input" value="false" [(ngModel)]="userIdDisable" />
                <label class="custom-control-label secloct text-capitalize" for="emailConsentNoRadio">
                  {{'customerOverview.false'| cxTranslate}}
                </label>
              </div>
            </section>
          </section>
        </section>
      }
      @if (!userIdEditIsNotClicked) {
        <section class="row w-100  btn-Row userId-btn-row">
          <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 pl-12 ">
            <button class="btn-secondary" (click)="cancelUserIdDisable()">
              {{'profile.cancel'|cxTranslate}}
            </button>
          </section>
          <section class="col-md-4 col-12 col-sm-12 col-lg-3 col-xl-3 pl-12 btnMargin-Top ">
            <button class="btn-primary" (click)="updateUserId()">
              {{'profile.update'|cxTranslate}}
            </button>
          </section>
        </section>
      }



    </section>
    <hr class="mb-1" />


    <!-- ==============================TABLE======================== -->
    <section class="row sectionPadding mb-32">
      <section class="col-md-9 col-9 col-sm-9">
        <h3 class="m-0"><span class="header-Css">
        {{'customerOverview.LastChangedHistory'| cxTranslate}} :</span></h3>
      </section>
    </section>
    <section class="col-12 col-sm-12 col-md-12 col-lg-12  tableDiv largeDevice-Table">
      <table aria-describedby="cardDetailsTable" class="table">
        <thead>
          <tr class="header-row">
            <th scope="col" class="header">{{'customerOverview.changedAtrribute'| cxTranslate}}</th>
            <th scope="col" class="header">{{'customerOverview.userChanged'| cxTranslate}} </th>
            <th scope="col" class="header">{{'customerOverview.ChangedTime'| cxTranslate}}</th>
            <th scope="col" class="header">{{'customerOverview.oldValue'| cxTranslate}}</th>
            <th scope="col" class="header">{{'customerOverview.newValue'| cxTranslate}}</th>
          </tr>
        </thead>

        <tbody>
          @for (i of changeHistoryArray; track i) {
            <tr class="content-row">
              <td class="statusTd col-Divider">
                {{i?.modifiedAttribute}}
              </td>
              <td class="col-Divider">
                {{i?.user}}
              </td>
              <td class="col-Divider">
                {{i?.modifiedTime}}
              </td>
              <td class="col-Divider">
                {{i?.oldValue}}
              </td>
              <td class="col-Divider">
                {{i?.newValue}}
              </td>
            </tr>
          }
          @if (changeHistoryArray?.length===0) {
            <tr class="content-row">
              <td colspan="5" class="text-center"><span></span>No Records Found</td>
            </tr>
          }
        </tbody>
      </table>

    </section>

    <!-- ===================Small Device Table================================ -->
    @for (i of changeHistoryArray; track i; let j = $index) {
      <section class="container smallDevice-Table sectionPadding"
        >
        <section class="row smallTable-Row">
          <section class="col-6 col-xs-6 col-md-6  small-table-padding">
            <span class="small-table-heading">{{'customerOverview.changedAtrribute'|
            cxTranslate}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding">
            <span class="small-table-value"> {{i?.modifiedAttribute}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding ">
            <span class="small-table-heading">{{'customerOverview.userChanged'|
            cxTranslate}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding">
            <span class="small-table-value"> {{i?.user}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding ">
            <span class="small-table-heading">{{'customerOverview.ChangedTime'|
            cxTranslate}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding">
            <span class="small-table-value"> {{i?.modifiedTime}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding">
            <span class="small-table-heading">{{'customerOverview.oldValue'| cxTranslate}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6  small-table-padding">
            <span class="small-table-value">{{i?.oldValue}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding">
            <span class="small-table-heading">{{'customerOverview.newValue'| cxTranslate}}</span>
          </section>
          <section class="col-6 col-xs-6 col-md-6 small-table-padding">
            <span class="small-table-value">{{i?.newValue}}</span>
          </section>
        </section>
      </section>
    }
    <!-- ======================/TABLE==================================== -->
    <section class="row sectionPadding">
      <section
        class="col-md-2 col-lg-2 col-xs-3 col-sm-3 d-flex d-lg-block d-xl-block d-md-block justify-content-center">
        <button class="btn-primary btn-margin-back " (click)="backToView()">
        {{'customerOverview.back'| cxTranslate}}</button>
      </section>
    </section>

    <!-- ======================================================================================== -->

  </section>
</section>
</section>
